import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";

//get some normalized state
//work data that has an ids array and then also has entities
const notesLabelsAdapter = createEntityAdapter({
  //try to put completed note into bottom
  sortComparer: (a, b) =>
    //true values first
    a.pinned === b.pinned && a.updatedAt > b.updateAt ? 0 : a.pinned ? -1 : 1,
});
const initialState = notesLabelsAdapter.getInitialState();

//injection into original slice
//RTKQuery create an hook based on this endpoint for use
export const notesLabelsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNotesWithThatLabel: builder.query({
      query: (name) => ({
        url: `/labels/${name}`,
        method: "GET",
        //params: { name: name },
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError; //make sure isn't error
        },
      }),
      //keepUnusedDataFor: 5, //5s => when production change to 60s(default)
      //useful when work with backend
      transformResponse: (responseData) => {
        const loadedNotesLabels = responseData?.map((labeledNote) => {
          labeledNote.id = labeledNote._id;
          return labeledNote;
        });
        return notesLabelsAdapter.setAll(initialState, loadedNotesLabels);
      },
      providesTags: (result, error, arg) => {
        //just fail safte
        if (result?.ids) {
          return [
            { type: "Note", id: "LIST" },
            ...result.ids.map((id) => ({ type: "Note", id })),
          ];
        } else return [{ type: "Note", id: "LIST" }];
      },
    }),
  }),
});

export const { useGetNotesWithThatLabelQuery } = notesLabelsApiSlice;

export const selectNotesLabelsResult =
  notesLabelsApiSlice.endpoints.getNotesWithThatLabel.select();

const selectNotesLabelsData = createSelector(
  selectNotesLabelsResult,
  (notesLabelsResult) => notesLabelsResult.data
);
//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
  selectAll: selectAllNotesLabels,
  // Pass in a selector that returns the notes slice of state
  //?? : return the right hand value if left hand value is undefined and null
} = notesLabelsAdapter.getSelectors(
  (state) => selectNotesLabelsData(state) ?? initialState
);
